import React, { createContext, useContext } from "react";

export interface KgCanvasNavigation {
  /** Focus a canvas node (same UX as clicking it on the graph). */
  focusNode: (nodeId: string) => void;
}

const KgCanvasNavigationContext = createContext<KgCanvasNavigation | null>(
  null,
);

const noopNavigation: KgCanvasNavigation = {
  focusNode: () => {},
};

export const KgCanvasNavigationProvider: React.FC<{
  value: KgCanvasNavigation;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <KgCanvasNavigationContext.Provider value={value}>
    {children}
  </KgCanvasNavigationContext.Provider>
);

/** Inspector tabs call this to navigate the canvas. No-op outside KgCanvas. */
export const useKgCanvasNavigation = (): KgCanvasNavigation =>
  useContext(KgCanvasNavigationContext) ?? noopNavigation;
